import config from "../config"
import axios from 'axios';
import router from '../Routes'
import * as Realm from 'realm-web'

const app = Realm.getApp(config.REALM_APP_ID);
var assert = require('assert');

export default {
  namespaced: true,
  state: {
    isFetching: false,
    errorMessage: ''
  },
  mutations: {
    LOGIN_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload;
    },
    LOGIN_SUCCESS(state) {
      state.isFetching = false;
      state.errorMessage = '';
    },
    LOGIN_REQUEST(state) {
      state.isFetching = true;
    }
  },
  actions: {
    loginUser({dispatch}, creds) {
      if (!config.isBackend) {
        dispatch('receiveToken', 'token');
      }
      else {
        dispatch('requestLogin');
        if (creds.social) {
          window.location.href = config.baseURLApi + "/auth/signin/" + creds.social + '?app=' + config.redirectUrl;
        }
        else
        if (creds.email.length > 0 && creds.password.length > 0) {
          dispatch('loginWithEmail', creds)
        }
        else
        {
          dispatch('loginError', 'Something was wrong. Try again');
        }
      }
    },
    async loginWithEmail({dispatch}, creds) {
      const credentials = Realm.Credentials.emailPassword(creds.email, creds.password);
      try {
        const user = await app.logIn(credentials);
        assert(user.id === app.currentUser.id)
        const token = user._accessToken;
        dispatch('receiveToken', token)
      } catch(err) {
        console.log(err);
        dispatch('loginError', err)
      }
    },
    receiveToken({dispatch}, token) {
      let user = app.currentUser.id;

      localStorage.setItem('token', token);
      localStorage.setItem('user', user);
      dispatch('receiveLogin');
    },
    logoutUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      axios.defaults.headers.common['Authorization'] = "";
      router.push('/login');
    },
    loginError({commit}, payload) {
      commit('LOGIN_FAILURE', payload);
    },
    receiveLogin({commit}) {
      commit('LOGIN_SUCCESS');
      router.push('/user/profile');
    },
    requestLogin({commit}) {
      commit('LOGIN_REQUEST');
    },
  }
}
